import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// 請求攔截器 - 添加認證 token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 響應攔截器 - 處理認證錯誤
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 清除本地存儲的認證信息
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // 重定向到登入頁面
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const evaluationDatabaseApi = {
  // 環境管理
  getEnvironments: () => api.get('/environments/').then(res => res.data),
  createEnvironment: (data) => api.post('/environments/', data).then(res => res.data),
  updateEnvironment: (id, data) => api.put(`/environments/${id}/`, data).then(res => res.data),
  deleteEnvironment: (id) => api.delete(`/environments/${id}/`).then(res => res.data),

  // 裝備管理
  getEquipment: () => api.get('/equipment/').then(res => res.data),
  createEquipment: (data) => api.post('/equipment/', data).then(res => res.data),
  updateEquipment: (id, data) => api.put(`/equipment/${id}/`, data).then(res => res.data),
  deleteEquipment: (id) => api.delete(`/equipment/${id}/`).then(res => res.data),

  // 姿勢管理
  getStances: () => api.get('/stances/').then(res => res.data),
  createStance: (data) => api.post('/stances/', data).then(res => res.data),
  updateStance: (id, data) => api.put(`/stances/${id}/`, data).then(res => res.data),
  deleteStance: (id, data) => api.delete(`/stances/${id}/`).then(res => res.data),

  // 問題類別管理
  getProblemCategories: () => api.get('/problem-categories/').then(res => res.data),
  createProblemCategory: (data) => api.post('/problem-categories/', data).then(res => res.data),
  updateProblemCategory: (id, data) => api.put(`/problem-categories/${id}/`, data).then(res => res.data),
  deleteProblemCategory: (id) => api.delete(`/problem-categories/${id}/`).then(res => res.data),

  // 問題管理
  getProblems: () => api.get('/problems/').then(res => res.data),
  createProblem: (data) => api.post('/problems/', data).then(res => res.data),
  updateProblem: (id, data) => api.put(`/problems/${id}/`, data).then(res => res.data),
  deleteProblem: (id) => api.delete(`/problems/${id}/`).then(res => res.data),

  // 改善類別管理
  getImprovementCategories: () => api.get('/improvement-categories/').then(res => res.data),
  createImprovementCategory: (data) => api.post('/improvement-categories/', data).then(res => res.data),
  updateImprovementCategory: (id, data) => api.put(`/improvement-categories/${id}/`, data).then(res => res.data),
  deleteImprovementCategory: (id) => api.delete(`/improvement-categories/${id}/`).then(res => res.data),

  // 動作詳細管理
  getMovementDetails: () => api.get('/movement-details/').then(res => res.data),
  createMovementDetail: (data) => api.post('/movement-details/', data).then(res => res.data),
  updateMovementDetail: (id, data) => api.put(`/movement-details/${id}/`, data).then(res => res.data),
  deleteMovementDetail: (id) => api.delete(`/movement-details/${id}/`).then(res => res.data),

  // 改善項目管理
  getImprovements: () => api.get('/improvements/').then(res => res.data),
  createImprovement: async (data) => {
    const response = await api.post('/improvements/', data);
    return response.data;
  },
  updateImprovement: async (id, data) => {
    const response = await api.put(`/improvements/${id}/`, data);
    return response.data;
  },
  deleteImprovement: (id) => api.delete(`/improvements/${id}/`).then(res => res.data),

  // 新增：獲取改善項目及其關聯的動作詳細
  getImprovementWithDetails: async (id) => {
    const response = await api.get(`/improvements/${id}/`);
    return response.data;
  },

  // 課程輔助相關 API
  getImprovementMovementDetails: async (improvementId) => {
    const response = await api.get(`/improvements/${improvementId}/movement-details/`);
    return response.data;
  },

  searchEvaluationsByProblem: async (problemId) => {
    const response = await api.get(`/search-evaluations-by-problem/${problemId}/`);
    return response.data;
  },

  // 獲取所有評估記錄
  getEvaluations: async () => {
    const response = await api.get('/evaluations/');
    return response;
  },
  
  // 新增：批量設置改善項目的動作詳細關聯
  setImprovementMovementDetails: async (improvementId, movementDetailIds) => {
    const response = await api.patch(`/improvements/${improvementId}/`, {
      movement_detail_ids: movementDetailIds
    });
    return response.data;
  },

  // 移除獲取改善類別對應的動作詳細
  // 移除統計信息
  getAllMovementDetails: () => api.get('/all-movement-details/').then(res => res.data),
  getStats: () => api.get('/evaluation-database-stats/').then(res => res.data),
};
